import platform from "../../../util/platform";
const create = (request) => {
    return (params) => {
        const path = `/app/account/invitation/create`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const update = (request) => {
    return (params) => {
        const path = `/app/account/invitation/update`;
        return platform.put(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const resendInvitation = (request) => {
    return (params) => {
        const path = `/app/account/invitation/resend`;
        return platform.put(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const deleteInvitation = (id) => {
    return (params) => {
        const path = `/app/account/invitation/delete/${id}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const getAll = () => {
    return (params) => {
        const path = `/app/account/invitations`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAllPaginated = (request) => {
    return (params) => {
        const query = platform.buildPaginatedQuery(request);
        const path = `/app/account/invitations/paginated?${query}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getById = (id) => {
    return (params) => {
        const path = `/app/account/invitation/id/${id}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getByAccessCode = (accessCode) => {
    return (params) => {
        const path = `/app/account/invitation/access-code/${accessCode}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const invitations = {
    create,
    update,
    resendInvitation,
    deleteInvitation,
    getAll,
    getAllPaginated,
    getById,
    getByAccessCode,
};
export default invitations;
